import { jsx as L } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ L(
  "path",
  {
    d: "M17.244 0.25H20.552L13.325 8.51L21.827 19.75H15.17L9.95603 12.933L3.99003 19.75H0.680028L8.41003 10.915L0.254028 0.25H7.08003L11.793 6.481L17.244 0.25ZM16.083 17.77H17.916L6.08403 2.126H4.11703L16.083 17.77Z",
    fill: "currentColor"
  }
);
export {
  t as default
};
